import hacktimer from 'hacktimer';
import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import { BootstrapVue } from 'bootstrap-vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueQrcode from '@chenfengyuan/vue-qrcode';

Vue.config.productionTip = false

Vue.config.errorHandler = function (err) {
	// handle error
	// `info` is a Vue-specific error info, e.g. which lifecycle hook
	// the error was found in. Only available in 2.2.0+
  // Ref: https://vuejs.org/v2/api/#errorHandler
  // Also check: https://vuejs.org/v2/api/#errorCaptured

  console.log("errorHandler",err)
}

// Vue.use(new VueSocketIO({
//   debug: false,
//   connection: 'http://localhost:8081',
//   vuex: {
//       store,
//       actionPrefix: 'SOCKET_',
//       mutationPrefix: 'SOCKET_'
//   },
//   options: { /* path: "/my-app/" */ } //Optional options
// }))

Vue.use(VueAxios,axios);
Vue.use(BootstrapVue);
Vue.use(hacktimer);

Vue.component(VueQrcode.name, VueQrcode);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
